import { createRoute, lazyRouteComponent } from "@tanstack/react-router";

import { rootRoute } from "./__root.js";

export const signRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: "/sign/$requestId",
  component: lazyRouteComponent(() => import("@l30/web-documents/pages/sign.page"), "SignPage"),
  validateSearch: (search): { token?: string; email?: string } => ({
    token: typeof search["token"] === "string" ? search["token"] : undefined,
    email: typeof search["email"] === "string" ? search["email"] : undefined,
  }),
});
